import { queryOptions } from "@tanstack/react-query";
import type { OccCartUserPath } from "~/app/api/occ/occUserPath";
import { fetchOccResourcePageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { CartStoreFinderPageInitialData } from "./cartStoreFinderPageInitialData";

export const cartStoreFinderPageQueryOptions = (userPath: OccCartUserPath, activeCartId?: string) =>
  queryOptions({
    queryKey: pageDataKeys.cartStoreFinder(userPath, activeCartId),
    queryFn: () =>
      fetchOccResourcePageData<PageInitialDataResult<CartStoreFinderPageInitialData>>(
        `${userPath}/carts/${encodeURIComponent(requireActiveCartId(activeCartId))}/page-data/cart/store-finder`,
      ),
    enabled: Boolean(activeCartId),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });

function requireActiveCartId(activeCartId: string | undefined): string {
  if (!activeCartId) {
    throw new Error("Cannot load Cart Store Finder page data without an Active Cart ID");
  }
  return activeCartId;
}
